import {_join} from '@string-plumbing/join';

/**
 * Concatenate an Array of strings.
 *
 * @param {string[]} strings
 * @return string
 */
const _concat = (strings) => _join(strings, '');
export default _concat;
